<template>
  <v-row no-gutters class="pt-5">
    <v-col cols="12">
      <v-row no-gutters>
        <v-col>
          <nmt-sidebar-profile-stats :statistics="statistics"> </nmt-sidebar-profile-stats>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col style="position: relative">
          <v-btn
            class="pa-2"
            style="position: absolute; top: 35px; right: 15px; opacity: .56; min-width: 37px;"
            @click="$emit('showDialog')"
            color="rgb(196, 196, 196)"
          >
            <v-icon color="font">
              mdi-magnify
            </v-icon>
          </v-btn>
          <nmt-sidebar-profile-chart v-bind="$props" v-on="$listeners"></nmt-sidebar-profile-chart>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import NmtSidebarProfileStats from '@/components/NmtSidebarProfileStats';
import NmtSidebarProfileChart from '@/components/NmtSidebarProfileChart';

export default {
  name: 'NmtSidebarProfile',
  components: {
    NmtSidebarProfileChart,
    NmtSidebarProfileStats,
  },
  props: {
    statistics: {
      type: Array,
      required: true,
    },
    heights: {
      type: Array,
      required: true,
    },
    interval: {
      type: Number,
      required: true,
    },
    length: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
